import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-flex align-items-start justify-content-between p-15 p-sm-20 p-md-25 gap-3 flex-wrap" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex align-items-center flex-nowrap"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-plus position-relative ms-5 fs-12" }, null, -1 /* HOISTED */)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "d-flex flex-wrap flex-column gap-3 justify-content-end align-items-end ms-auto" }
const _hoisted_7 = {
  key: 0,
  class: "card-select align-items-center d-inline-flex ms-auto"
}
const _hoisted_8 = { class: "fw-medium text-muted me-8" }
const _hoisted_9 = {
  value: -1,
  class: "fw-medium"
}
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "d-inline-flex flex-wrap jusify-content-end gap-3" }
const _hoisted_12 = { class: "search-box position-relative" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "search-box position-relative" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = { class: "d-flex gap-3 flex-row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-x" }, null, -1 /* HOISTED */)
const _hoisted_18 = { class: "fs-10" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-magnifying-glass fs-16" }, null, -1 /* HOISTED */)
const _hoisted_20 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_21 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_22 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_23 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_24 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_25 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_26 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_27 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_28 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
}, null, -1 /* HOISTED */)
const _hoisted_30 = { class: "linked" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 0,
  class: "shadow-none lh-1 fw-medium text-body-tertiary text-end"
}
const _hoisted_38 = { class: "dropdown position-static" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  "data-bs-boundary": "viewport"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
], -1 /* HOISTED */)
const _hoisted_40 = { class: "dropdown-menu" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-eye lh-1 me-8 position-relative top-1" }, null, -1 /* HOISTED */)
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-pencil lh-1 me-8 position-relative top-1" }, null, -1 /* HOISTED */)
const _hoisted_45 = { key: 2 }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-trash lh-1 me-8 position-relative top-1" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_TablePagination = _resolveComponent("TablePagination")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.enableAddPatient)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_ctx.storeEnabled)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/create-patient",
                    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('cta.create_patient')) + " ", 1 /* TEXT */),
                      _hoisted_4
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_5)),
        _createElementVNode("div", _hoisted_6, [
          _createCommentVNode(" CENTER FILTER "),
          ((_ctx.centers?.length ?? 0) > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('form.center_id.label')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select shadow-none text-black border-0 p-15 pe-50 bg-body-tertiary fs-14 fw-medium",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.centerId) = $event)),
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setFilter && _ctx.setFilter(...args)))
                }, [
                  _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.$t('cta.show_all')), 1 /* TEXT */),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.centers, (center) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: center.id,
                      value: center.id,
                      class: "fw-medium"
                    }, _toDisplayString(center.name), 9 /* TEXT, PROPS */, _hoisted_10))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                  [_vModelSelect, _ctx.centerId]
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_11, [
            _createCommentVNode(" TEXT FILTER "),
            _createElementVNode("form", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control shadow-none text-black rounded-0 border-0",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.textQuery) = $event)),
                placeholder: _ctx.$t('cta.search'),
                onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.setFilter && _ctx.setFilter(...args)), ["enter"]))
              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_13), [
                [_vModelText, _ctx.textQuery]
              ]),
              _createCommentVNode(" <button type=\"submit\" class=\"bg-transparent text-primary transition p-0 border-0 mt-0\">\n                        <i class=\"ph ph-magnifying-glass\"></i>\n                    </button> ")
            ]),
            _createCommentVNode(" EMAIL FILTER "),
            _createElementVNode("form", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control shadow-none text-black rounded-0 border-0",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.emailQuery) = $event)),
                placeholder: _ctx.$t('form.email.label'),
                onKeydown: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.setFilter && _ctx.setFilter(...args)), ["enter"]))
              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_15), [
                [_vModelText, _ctx.emailQuery]
              ]),
              _createCommentVNode(" <button type=\"submit\" class=\"bg-transparent text-primary transition p-0 border-0 mt-0\">\n                        <i class=\"ph ph-magnifying-glass\"></i>\n                    </button> ")
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_ctx.filters)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "bg-transparent text-muted transition p-0 border-0 mt-0 text-uppercase d-flex align-items-center gap-1",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)))
                }, [
                  _hoisted_17,
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('cta.clear_filters')), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("button", {
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.setFilter && _ctx.setFilter(...args))),
              class: "default-btn position-relative transition border-0 fw-medium text-white pt-10 pb-10 ps-10 pe-10 rounded-1 bg-success fs-13 d-inline-flex text-decoration-none gap-3 align-items-center"
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('cta.search')) + " ", 1 /* TEXT */),
              _hoisted_19
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        (_ctx.patients === undefined || _ctx.patients === null)
          ? (_openBlock(), _createBlock(_component_SpinnerLoading, {
              key: 0,
              class: "mt-50"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("table", _hoisted_22, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.$t('form.last_name.label').toUpperCase()), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.$t('form.first_name.label').toUpperCase()), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.$t('form.center_id.label').toUpperCase()), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.$t('form.birth_date.label').toUpperCase()), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.$t('form.gender.label').toUpperCase()), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.$t('form.created_at.label').toUpperCase()), 1 /* TEXT */),
                    _hoisted_29
                  ])
                ]),
                _createElementVNode("tbody", _hoisted_30, [
                  _createCommentVNode(" PATIENT ROW "),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.patients! as PatientInfo[]), (patient) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: patient!.id
                    }, [
                      _createElementVNode("th", {
                        class: "shadow-none lh-1 fw-medium text-black-emphasis title",
                        onClick: ($event: any) => (_ctx.show(patient))
                      }, _toDisplayString(patient.lastname), 9 /* TEXT, PROPS */, _hoisted_31),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-black-emphasis title",
                        onClick: ($event: any) => (_ctx.show(patient))
                      }, _toDisplayString(patient.firstname), 9 /* TEXT, PROPS */, _hoisted_32),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-black-emphasis",
                        onClick: ($event: any) => (_ctx.show(patient))
                      }, [
                        (!(((_ctx.patientCenter(patient.center_id)?.is_custom_center ?? false) == true) || ((patient.self_registration ?? false) == true)))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.patientCenter(patient.center_id)?.name ?? patient.center_id), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ], 8 /* PROPS */, _hoisted_33),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-muted",
                        onClick: ($event: any) => (_ctx.show(patient))
                      }, [
                        ((patient.self_registration ?? false) == false)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(patient.birthdate), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ], 8 /* PROPS */, _hoisted_34),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-muted",
                        onClick: ($event: any) => (_ctx.show(patient))
                      }, [
                        ((patient.self_registration ?? false) == false)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(patient.sex != null ? _ctx.$t(`form.gender.${patient.sex}`) : ''), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ], 8 /* PROPS */, _hoisted_35),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-muted",
                        onClick: ($event: any) => (_ctx.show(patient))
                      }, [
                        ((patient.self_registration ?? false) == false)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(patient.created_at !== undefined ? _ctx.formatDate(patient.created_at) : ''), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ], 8 /* PROPS */, _hoisted_36),
                      (_ctx.showActions(patient.center_id) || ((patient.self_registration ?? false) == true))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                              _hoisted_39,
                              _createElementVNode("ul", _hoisted_40, [
                                (_ctx.centerPermission(patient.center_id, 'show') || ((patient.self_registration ?? false) == true))
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_41, [
                                      _createVNode(_component_router_link, {
                                        to: { path: `/patient/${patient.id}` },
                                        class: "dropdown-item d-flex align-items-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_42,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.view')), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                (_ctx.centerPermission(patient.center_id, 'update'))
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_43, [
                                      _createVNode(_component_router_link, {
                                        to: { path: `/patient/${patient.id}/edit` },
                                        class: "dropdown-item d-flex align-items-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_44,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.edit')), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                (_ctx.centerPermission(patient.center_id, 'destroy'))
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_45, [
                                      _createElementVNode("button", {
                                        class: "dropdown-item d-flex align-items-center",
                                        onClick: ($event: any) => (_ctx.confirmDeletePatient(patient))
                                      }, [
                                        _hoisted_47,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.delete')), 1 /* TEXT */)
                                      ], 8 /* PROPS */, _hoisted_46)
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */)),
                  _createCommentVNode("  ")
                ])
              ])
            ])),
        _createCommentVNode(" PAGINATION "),
        _createVNode(_component_TablePagination, {
          count: _ctx.patients?.length ?? 0,
          page: _ctx.currentPage,
          total: _ctx.totalPatients,
          pages: _ctx.lastPage,
          onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setPage($event)))
        }, null, 8 /* PROPS */, ["count", "page", "total", "pages"])
      ])
    ]),
    _createVNode(_component_ConfirmModal, {
      onConfirm: _cache[9] || (_cache[9] = ($event: any) => (_ctx.deletePatient())),
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}